<div mat-dialog-title>
  <div class="d-flex justify-content-between align-items-center">
    <h2>Attachments</h2>
    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
      <i class="fa fa-times" style="color: #fff"></i>
    </button>
  </div>
</div>
<form [formGroup]="filesForm" novalidate>
  <span
    *ngIf="
      !filesForm.get('file')?.value || filesForm.get('file')?.value.length === 0
    "
    style="font-size: medium; margin-right: -128px; margin-left: 11px"
  >
    Add header files
  </span>
  <mat-form-field
    *ngIf="!isView"
    appearance="fill"
    style="width: 14rem"
    class="top-row-first-filed-item top-row-first-filed-item-order-processing"
  >
    <ngx-mat-file-input
      #myInput
      formControlName="file"
      [accept]="
        'image/x-png,image/gif,image/jpeg,image/jpg,application/pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,video/*,audio/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/rtf,text/plain'
      "
      [multiple]="true"
      placeholder="Add NCR Files"
      (change)="readFile($event)"
      [maxFileCount]="5"
    >
      <mat-icon ngxMatFileInputIcon>folder</mat-icon>
    </ngx-mat-file-input>
  </mat-form-field>
</form>
<div class="mat-elevation-z8">
  <table mat-table [dataSource]="previewerData" class="preview_table">
    <ng-container matColumnDef="Desc">
      <th mat-header-cell *matHeaderCellDef style="padding-right: 45rem">
        File Description
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.fileName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef style="padding-right: 5rem">
        Download
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        style="padding-left: 20px !important"
      >
        <a [href]="element.filePath" download="{{ element.fileName }}">
          <i class="fa fa-download"></i>
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="View">
      <th mat-header-cell *matHeaderCellDef style="padding-right: 5rem">
        View
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        style="padding-left: 8px !important"
      >
        <!-- <a [href]="element.filePath" download="{{ element.fileName }}"> -->
        <i class="fa fa-eye" (click)="ViewFile(element.filePath)"></i>
        <!-- </a> -->
      </td>
    </ng-container>

    <ng-container matColumnDef="Remove">
      <th mat-header-cell *matHeaderCellDef style="padding-right: 5rem">
        <button mat-icon-button matTooltip="Clear All" *ngIf="!isView">
          <mat-icon>clear_all</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          matTooltip="Remove this File"
          *ngIf="!isView"
          (click)="removeFile(element)"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="previewerColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: previewerColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="3">No data found</td>
    </tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
  ></mat-paginator>
</div>

<ng-template #viewdocument>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">View File</h1>
      <button
        mat-mini-fab
        mat-button
        color="warn"
        title="close"
        (click)="closeDialog()"
      >
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <mat-dialog-content style="max-height: 80vh">
    <div class="col-12">
      <ngx-doc-viewer
        *ngIf="fileType === 'doc'"
        [url]="doc"
        viewer="google"
        style="width: 100%; height: 90vh"
      ></ngx-doc-viewer>
      <angular-image-viewer
        *ngIf="fileType === 'image'"
        [src]="images"
        [(index)]="imageIndexOne"
      ></angular-image-viewer>
      <div *ngIf="fileType === 'video'" class="file-viewer">
        <video
          [src]="viewDocument"
          controls
          style="width: 100%; height: auto"
        ></video>
      </div>
      <div *ngIf="fileType === 'unknown'" class="file-viewer">
        <a [href]="viewDocument" target="_blank">Open File</a>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>
